import { useRouting } from '@hooks/useRouting';

import { PLATFORM } from '@constants/index';
import styles from './Layout.module.scss';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import { useSessionContext } from '@contexts/SessionContextProvider';

const Layout = ({ children }) => {
  const { queryParams } = useRouting();
  const { platform } = queryParams;
  const { pathname } = useLocation();
  const { state } = useSessionContext();

  const isKiosk =
    platform === PLATFORM.KIOSK && pathname === '/interview' && !state?.sessionInfo?.isCompleted;

  return (
    <div
      className={clsx(styles.layout, {
        [styles.kioskLayout]: isKiosk,
      })}
    >
      <main className={styles.mainLayout}>{children}</main>
    </div>
  );
};

export default Layout;
